module.exports = __webpack_public_path__ + "static/media/logo_whatsapp.f55da47a.png";